import { render, staticRenderFns } from "./StuffingOrderCard.vue?vue&type=template&id=0b3717a6"
import script from "./StuffingOrderCard.vue?vue&type=script&lang=js"
export * from "./StuffingOrderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports